// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2_LtN","label":"SetPasswdForm_label__1yXgT"};